// extracted by mini-css-extract-plugin
export default {"titleDec":"index_titleDec__+ORM2","content":"index_content__LW2xm","oaContractUrls":"index_oaContractUrls__IIuD4"};